






































import { Component, Vue, Watch } from 'vue-property-decorator'
import { ModuleOption, InformationCodes } from '@/data/enums'
import OptionModule from '@/components/OptionModule.vue'
import GlassOptionValue from '@/data/glass-option-value'
import GlassOption from '@/data/glass-option'
import '@/icons/options-prisma'
@Component({
  components: {
    OptionModule
  }
})
export default class ErgoDesignModule extends Vue {
  private informationCode: string = InformationCodes.ModuleErgodesign
  private optionId: number = ModuleOption.Ergo

  private thumbnail (id: number): string {
    switch (id) {
      case 71:
        return 'module/design/design_book.png'
      case 72:
        return 'module/design/design_pc.png'
      case 73:
        return 'module/design/design_room.png'
    }
    return ''
  }

  private get optionIds (): ModuleOption[] {
    return [this.optionId]
  }
  private selectOption (optionValue: GlassOptionValue) {
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
